export enum AttachmentFillType {
  Nonfilled = 'nonfilled',
  Filled = 'filled',
}
